import type { DrugSelectionRule, PatientInput } from "../types";

export function matchesDrugSelectionRule(
  rule: DrugSelectionRule,
  patient: PatientInput,
  contextValues: Record<string, unknown>,
): boolean {
  if (rule.minAge !== undefined && patient.ageYears < rule.minAge) return false;
  if (rule.maxAge !== undefined && patient.ageYears > rule.maxAge) return false;
  if (rule.condition === "always") return true;
  if (typeof rule.condition === "function") return !!rule.condition(patient);
  if (!rule.when || typeof rule.when !== "object") return false;
  return Object.entries(rule.when).every(([key, value]) => {
    const contextValue = contextValues[key];
    if (contextValue !== undefined) return contextValue === value;
    return (patient as unknown as Record<string, unknown>)[key] === value;
  });
}
